import React from 'react';
import { DateRangeFilter } from '../DateRangeFilter';
import { RangeItem } from '@wix/bex-core';
import { FilterProps } from '../../model';
import { DateCustomFieldFilterBase } from './DateCustomFieldFilterBase';

interface DateCustomFieldFilterProps extends FilterProps<RangeItem<Date>> {}

export const DateCustomFieldFilter = (props: DateCustomFieldFilterProps) => {
  return <DateCustomFieldFilterBase {...props} />;
};

DateCustomFieldFilter.renderPresetToolbarTag =
  DateRangeFilter.renderPresetToolbarTag;
